import type { FitbitExportFormat } from '../../../services/fitbitExtractionService';

export const fitbitExportFormats: Record<FitbitExportFormat, { label: string; description: string }> = {
  zip: { label: 'Research tables (.zip)', description: 'Separate CSV tables for your selected measurements, plus a data dictionary.' },
  json: { label: 'JSON (.json)', description: 'A complete document with extraction details and original structured measurements.' },
  ndjson: { label: 'JSON Lines (.ndjson)', description: 'One record per line, suited to large datasets and analysis pipelines.' },
  csv: { label: 'CSV (.csv)', description: 'A spreadsheet table. Nested measurements, sleep stages and original timestamps remain in JSON columns.' },
};
